import useGroupAPIStore from "apis/admin/group.api";
import useToastErrorMessage from "hooks/useToastErrorMessage";
import { useEffect, useState } from "react";
import useModalStore from "stores/useModalStore";
import { GroupNameType } from "types/admin/AdminType";
import { DropDownListOptionType } from "types/common/CommonType";

const useGroupDropdown = () => {
  const { getGroupNameList } = useGroupAPIStore();
  const [groupList, setGroupList] = useState<DropDownListOptionType<string>[]>(
    []
  );

  const [pending, setPending] = useState<boolean>(false);
  const { showToastErrorMessage } = useToastErrorMessage();
  const { libraryImportModal } = useModalStore();

  const fetchGroupListForDropdown = async () => {
    setPending(true);
    const { resultList }: { resultList: GroupNameType[]; code: number } =
      await getGroupNameList(libraryImportModal ? true : false);

    const formatResultList = resultList?.map((group: GroupNameType) => {
      return {
        label: group.groupName,
        value: group.groupId,
      };
    });

    setGroupList(resultList?.length > 0 ? formatResultList : []);
    setPending(false);
  };

  useEffect(() => {
    fetchGroupListForDropdown();
  }, []);

  /** 선택한 groupId( 없으면 groupName ) 으로 groupPermission에 맞는 타입으로 변환 @author c_bae */
  const getSelectedGroupInfo = (
    groupIdOrGroupName: string,
    originSearchList: DropDownListOptionType<string>[]
  ) => {
    const selectedGroupInfo = originSearchList?.find((item) =>
      item.value === groupIdOrGroupName
        ? true
        : item.label === groupIdOrGroupName
    );

    if (!selectedGroupInfo) {
      showToastErrorMessage("The selected group cannot be found.", 5000);
      return null;
    }
    return selectedGroupInfo;
  };

  return {
    groupList,
    pending,
    fetchGroupListForDropdown,
    getSelectedGroupInfo,
  };
};
export default useGroupDropdown;
